import React from 'react';
import ReactDOM from 'react-dom/client';
import '@fontsource-variable/orbitron';
import '@fontsource-variable/jetbrains-mono';
import './styles/index.css';
import App from './App.jsx';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);